import { useMemo } from 'react';
import { ResponsivePieCard } from '@/shared/components';
import { useLpStats } from '@/shared/hooks';
import { usePolkadot } from '@/shared/hooks/usePolkadot';

export const PortfolioBreakdownCard = ({ isMobileView }: { isMobileView?: boolean }) => {
  const { selectedAccount } = usePolkadot();
  const {
    liquidityDataLoading,
    boostLiquidityUsd,
    deployedLiquidityUsd,
    undeployedLiquidityUsd,
    totalLiquidityUsd,
  } = useLpStats(selectedAccount?.idSs58);

  const colors = ['#46DA93', '#FF33AF', '#F4BD8A'];
  const data = useMemo(
    () => [
      {
        color: colors[0],
        label: 'Open Orders',
        id: 'deployed-liquidity',
        absoluteValue: deployedLiquidityUsd,
        value: (deployedLiquidityUsd / totalLiquidityUsd) * 100 || 0,
      },
      {
        color: colors[1],
        label: 'Boost Positions',
        id: 'boost-liquidity',
        absoluteValue: boostLiquidityUsd,
        value: (boostLiquidityUsd / totalLiquidityUsd) * 100 || 0,
      },
      {
        color: colors[2],
        label: 'Balance',
        id: 'undeployed-liquidity',
        value: (undeployedLiquidityUsd / totalLiquidityUsd) * 100 || 0,
        absoluteValue: undeployedLiquidityUsd,
      },
    ],
    [deployedLiquidityUsd, boostLiquidityUsd, undeployedLiquidityUsd, totalLiquidityUsd],
  );

  return (
    <ResponsivePieCard
      title="Portfolio Breakdown"
      totalValue={totalLiquidityUsd}
      data={data}
      tooltipContent="A detailed view of the distribution of your portfolio value across open orders, boost positions, and balance"
      loading={liquidityDataLoading}
      isMobileView={isMobileView}
    />
  );
};
